var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSteam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Steam"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21 12C21 16.9718 16.9645 21 11.9855 21C7.85565 21 4.37903 18.231 3.3121 14.4532L6.76694 15.8794C6.99919 17.0444 8.03347 17.9262 9.26734 17.9262C10.6899 17.9262 11.8766 16.7504 11.8149 15.2589L14.8815 13.0742C16.7722 13.1214 18.3581 11.5899 18.3581 9.68105C18.3581 7.80847 16.8339 6.2879 14.9577 6.2879C13.0815 6.2879 11.5573 7.8121 11.5573 9.68105V9.7246L9.40887 12.8347C8.84637 12.802 8.29476 12.9581 7.83024 13.2738L3 11.2778C3.37016 6.64355 7.2496 3 11.9855 3C16.9645 3 21 7.02823 21 12ZM8.6504 16.656L7.54355 16.1988C7.74695 16.6211 8.09814 16.9543 8.53064 17.1351C9.50685 17.5415 10.6282 17.077 11.0347 16.1044C11.2306 15.6327 11.2343 15.1137 11.0383 14.6419C10.8423 14.1702 10.4758 13.8 10.004 13.604C9.53589 13.4081 9.03508 13.4153 8.59234 13.5823L9.73548 14.054C10.454 14.3516 10.7952 15.1754 10.494 15.894C10.1927 16.6161 9.36895 16.9536 8.6504 16.656V16.656ZM14.9577 11.9419C13.7093 11.9419 12.6931 10.9258 12.6931 9.68105C12.6931 8.43629 13.7093 7.42016 14.9577 7.42016C16.206 7.42016 17.2222 8.43629 17.2222 9.68105C17.2222 10.9258 16.2097 11.9419 14.9577 11.9419V11.9419ZM14.9613 11.3758C15.9012 11.3758 16.6633 10.6137 16.6633 9.67742C16.6633 8.7375 15.9012 7.97903 14.9613 7.97903C14.0214 7.97903 13.2593 8.74113 13.2593 9.67742C13.2629 10.6137 14.025 11.3758 14.9613 11.3758Z",
    fill: "#F7FCFD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteam);
export default __webpack_public_path__ + "static/media/Steam.476d08f5836092e5f27cb88a1291490f.svg";
export { ForwardRef as ReactComponent };